// extracted by mini-css-extract-plugin
module.exports = {"page":"Hat_page__mx2N_"};